var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOffDutyLoop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 78,
  height: 87,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#262B2F",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M16.693 19.155c.999 6.012 3.55 12.603 9.033 15.89 1.389.833 3.03 1.29 4.7 1.37m0 0c2.54.121 5.144-.63 7.01-2.255 2.918-2.543 4.803-6.343 3.08-10.068-.897-1.941-2.533-3.242-4.754-2.703-3.393.822-5.294 5.387-5.582 8.485-.2 2.143-.108 4.348.245 6.54ZM50.88 75.322c-4.869-3.665-9.533-8.974-9.914-15.356-.096-1.616.258-3.283.959-4.8m0 0c1.067-2.31 2.937-4.271 5.24-5.174 3.604-1.412 7.845-1.326 10.352 1.923 1.306 1.693 1.703 3.745.2 5.465-2.299 2.629-7.225 2.205-10.106 1.027-1.992-.814-3.905-1.914-5.686-3.241Zm0 0c-6.258-4.661-10.86-11.239-11.558-18.801M43.98 75.517c1.702.298 5.632.852 7.74.684"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#262B2F",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M51.718 76.203c-.214-1.714-.575-5.666-.305-7.764"
})));
export default SvgOffDutyLoop;